
function replaceElement_(oldElement, newElement, html){
    if(oldElement.outerHTML){
        oldElement.outerHTML = html
    }else if(oldElement.replaceWith){
        oldElement.replaceWith(newElement)
    }
}

function replaceElement(html, cb) {
    try {
        let createTag = 'div';
        html = html.trim()
        if(html.indexOf('<tbody') < 4 || html.indexOf('<thead') < 4){
            createTag = 'table';
        } else
        if(html.indexOf('<tr') < 2){
            createTag = 'tbody';
        } else
        if(html.indexOf('<td') < 2){
            createTag = 'tr';
        }
        let parentNewElement = document.createElement(createTag);
        parentNewElement.innerHTML = html
        let newElement = parentNewElement.children[0]

        let id = newElement.id
        if(id){
            let oldElement = document.getElementById(id);
            if(oldElement){
                replaceElement_(oldElement, newElement, html)
                cb(document.getElementById(id))
            }
        }else{
            let selector = '.'+ newElement.classList.value.replace(/ +/g, ' ')
                .trim().replace(' ', '.')
            let oldElements = document.querySelectorAll(selector);
            for (let i = 0; i < oldElements.length; i++) {
                let oldElement = oldElements[i]
                replaceElement_(oldElement, newElement, html)
            }
            let newElements = document.querySelectorAll(selector);
            for (let i = 0; i < newElements.length; i++) {
                let newElement = newElements[i]
                cb(newElement)
            }
        }
    }catch (er){
        console.error(er)
    }
}

export default function ReplaceElements(elements, cb) {
    if(!cb){
        cb = function (){}
    }
    elements.forEach(function (html){
        replaceElement(html, cb)
    })
}
